import {create} from 'zustand';

interface ProductionStore {
    formData: any;
    setFormData: (data: any) => void;

    clientFiles: any[];
    setClientFiles: (clientFiles: any[]) => void;

    users: any[];
    setUsers: (users: any[]) => void;

    departments: any[];
    setDepartments: (departments: any[]) => void;

    production2: any;
    setProduction2: (production2: any) => void;

    production: any;
    setProduction: (production: any) => void;

    isLoading: boolean;
    setIsLoading: (isLoading: boolean) => void;

    resetProduction: () => void;
}

export const useProductionStore = create<ProductionStore>((set) => ({
    formData: {},
    setFormData: (formData) => set({formData}),

    clientFiles: [],
    setClientFiles: (clientFiles) => set({clientFiles}),

    users: [],
    setUsers: (users) => set({users}),

    departments: [],
    setDepartments: (departments) => set({departments}),

    production2: {},
    setProduction2: (production2) => set({production2}),

    production: [],
    setProduction: (production) => set({production}),

    isLoading: false,
    setIsLoading: (isLoading) => set({isLoading}),

    resetProduction: () => set({ formData: {} }),
}));